export * from './page-watch-list-bid/page-watch-list-bid.component';